import React, { FunctionComponent } from 'react';

import { Route, Routes } from 'react-router';

import { CallPage } from '../../../../../../pages/call';
import type { ErrorPageType } from '../../../../../components/error-page/types';
import { PSNotifications } from '../../../../notifications/ps-notifications';

interface CallsWithSidebarViewProps {
    withChat?: boolean;
    errorPageType: ErrorPageType | null;
}

export const CallsWithSidebarView: FunctionComponent<CallsWithSidebarViewProps> = ({ withChat, errorPageType }) => {
    if (errorPageType) {
        return null;
    }

    return (
        <Routes>
            <Route
                path="/j/:id"
                element={
                    <>
                        <CallPage isChatAllowed={withChat} />
                        <PSNotifications />
                    </>
                }
            />
        </Routes>
    );
};
